<template>
    <!-- Form for preview -->
    <form
        id="gift-creation-form"
        method="POST"
        action="/gift/pay"
    >
        <input
            type="hidden"
            name="_token"
            :value="csrf"
        >
        <input
            type="hidden"
            name="mode"
            :value="mode"
        >
        <input
            type="hidden"
            name="uuid"
            :value="uuid"
        >
        <input
            type="hidden"
            name="currency"
            :value="currency"
        >
        <input
            type="hidden"
            name="modules[]"
            :value="modules"
        >
        <input
            type="hidden"
            name="lessons[]"
            :value="lessons"
        >
        <!-- Occasion -->
        <div class="mb-3 d-none">
            <label
                class="form-label"
                for="input-occasion"
            >
                Повод (стиль оформления):
            </label>
            <select
                id="input-occasion"
                v-model="params.occasion"
                class="form-select"
                aria-label="Повод (оформление)"
                name="occasion"
            >
                <option value="default">
                    Без повода
                </option>
                <option value="new-year">
                    Новый год
                </option>
                <!--<option value="birthday">-->
                <!--    День рождения-->
                <!--</option>-->
                <!--<option value="knowledge-day">-->
                <!--    День знаний-->
                <!--</option>-->
                <!--<option value="other">-->
                <!--    Другое-->
                <!--</option>-->
            </select>
        </div>

        <!-- Recipient name -->
        <div class="mb-3">
            <label
                class="form-label"
                for="input-recipient-name"
            >
                Обращение к получателю:
            </label>
            <input
                id="input-recipient-name"
                v-model="params.recipientName"
                class="form-control"
                placeholder="Например: Аня"
                name="recipient_name"
            >
        </div>

        <!-- Main text -->
        <div class="mb-2">
            <label
                for="input-text"
                class="form-label"
            >
                Добавьте приятных слов подарку:
            </label>
            <textarea
                id="input-text"
                v-model="params.text"
                class="form-control"
                rows="4"
                placeholder="Например: Пусть учёба будет увлекательным приключением! Добивайся поставленных целей и верь в успех!"
                name="text"
            />
        </div>

        <!-- The gift preview -->
        <a
            target="_blank"
            class="gift-preview-link link-dashed"
            href=""
            @click.prevent="preview"
        >
            Посмотреть, как будет выглядеть подарок
            <i class="icon-new-tab"/>
        </a>

        <!-- Sender email -->
        <div class="mt-3 mb-3">
            <label
                class="form-label"
                for="input-sender-email"
            >
                Ваша почта (для отправки квитанции об оплате):
            </label>
            <input
                id="input-sender-email"
                v-model="params.senderEmail"
                class="form-control"
                placeholder="example@mail.ru"
                required
                name="sender_email"
                type="email"
            >
        </div>

        <div class="form-check d-flex">
            <input
                id="offer-agree"
                class="form-check-input me-2 flex-shrink-0"
                required
                type="checkbox"
                name="offer-agree"
                autocomplete="off"
            >
            <label
                class="form-check-label text-start cursor-pointer"
                for="offer-agree"
            >
                <!-- eslint-disable-next-line vue/max-attributes-per-line -->
                Я принимаю условия <a target="_blank" class="link-primary" href="/user-agreement">пользовательского соглашения</a>, <a target="_blank" class="link-primary" href="/offer-and-acceptance">публичной оферты</a> и даю <a target="_blank" class="link-primary" href="/data-agreement">согласие</a> на обработку своих персональных данных.
            </label>
        </div>

        <input
            class="btn btn-success mt-3"
            type="submit"
            value="Перейти к оплате"
        >
    </form>
</template>

<script>
export default {
    name: "GiftForm",
    props: {
        csrf: {
            type: String,
            default: ''
        },
        mode: {
            type: String,
            default: ''
        },
        uuid: {
            type: String,
            default: ''
        },
        currency: {
            type: String,
            default: ''
        },
        modules: {
            type: String,
            default: ''
        },
        lessons: {
            type: String,
            default: ''
        },
        recipientNameOld: {
            type: String,
            default: ''
        },
        textOld: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            params: {
                // occasion: 'new-year',
                occasion: 'default',
                recipientName: this.recipientNameOld ?? '',
                senderEmail: '',
                text: this.textOld ?? '',
            },
        }
    },
    methods: {
        preview() {
            let $form = $('<form target="_blank" method="POST" action="/gift/preview">')
                .append(`<input type="hidden" name="_token" value="${this.csrf}">`)
                .append(`<input name="occasion" value="${this.params.occasion}">`)
                .append(`<input name="recipient_name" value="${this.params.recipientName}">`)
                .append(`<input name="text" value="${this.params.text}">`)
                .append(`<input name="mode" value="${this.mode}">`)
                .append(`<input name="modules[]" value="${this.modules}">`)
                .append(`<input name="lessons[]" value="${this.lessons}">`)
            $('#gift-creation-form').after($form)
            $form.submit().remove()
        },
    }
}
</script>

<style scoped lang="scss">
.gift-preview-link {
    color: #0d6efd;
    i {
        margin-left: 2px;
        font-size: 14px;
    }
}
.email-spoiler-link {
    color: #0d6efd;
    i {
        margin-left: 7px;
        transition: .2s ease;
    }
    &.opened {
        & > i {
            transform: rotate(-180deg);
        }
    }
}
</style>
